enum HTMLInputElementSelectionDirectionEnum {
	none = 'none',
	forward = 'forward',
	backward = 'backward'
}
export default HTMLInputElementSelectionDirectionEnum;
